// @ts-check
import PropTypes from 'prop-types';

import { countries, states } from 'services/inputTokens';
import { getFilter } from 'selectors/organisation';
import { setFilterGroup } from 'actions/organisation';
import { tagRender } from 'components/common/TagRender';
import { renderOption } from 'components/common/OptionRender';

import OrgFilterField from './OrgFilterField';
import OrgFilterSection from './OrgFilterSection';

const activeKeys = ['country', 'state', 'city', 'postcode'];

const OrgLocationSection = ({ organisationId, loading }) => (
  <OrgFilterSection
    organisationId={organisationId}
    icon='map'
    title='Location'
    activeKeys={activeKeys}
  >
    <OrgFilterField
      filterType='selectIncludeExclude'
      mode={'multiple'}
      style={{ width: '100%' }}
      renderOption={renderOption}
      tagRender={tagRender}
      filterId='country'
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
      options={countries}
      placeholder='Region / Country'
      disabled={loading}
      remoteSearchOnClick
    />
    <OrgFilterField
      filterType='selectIncludeExclude'
      mode={'multiple'}
      style={{ width: '100%' }}
      tagRender={tagRender}
      filterId='state'
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
      options={states}
      placeholder='States'
      optionProp={{ optionLabel: 'displayName', optionValue: 'id' }}
      disabled={loading}
      remoteSearchOnClick
    />
    <OrgFilterField
      filterType='token'
      filterId='city'
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
      placeholder='Cities'
      disabled={loading}
      includeExclude
    />
    <OrgFilterField
      filterType='token'
      filterId='postcode'
      organisationId={organisationId}
      setFilterGroup={setFilterGroup}
      getFilter={getFilter}
      placeholder='Zip / Postal Code'
      disabled={loading}
      includeExclude
    />
  </OrgFilterSection>
);

OrgLocationSection.propTypes = {
  organisationId: PropTypes.number.isRequired,
  loading: PropTypes.bool,
};

export default OrgLocationSection;
